export default function openPaddle({
  productId,
  passthrough,
  email,
}: any): void {
  const checkoutObj: any = {
    product: productId,
    passthrough,
    email: email || undefined,
    success: '/connect',
  }

  Object.keys(checkoutObj).forEach((key: string) => {
    if (typeof checkoutObj[key] === 'undefined') {
      delete checkoutObj[key]
    }
  })

  try {
    // @ts-ignore
    window.Paddle.Checkout.open(checkoutObj)
  } catch (e) {
    console.log('Issue with Paddle:', { e })
  }
}

export function getPaddlePrice({ productId, setPrice }: any): void {
  try {
    // @ts-ignore
    window.Paddle.Product.Prices(productId, (prices) => {
      if (setPrice) {
        setPrice(prices.price.gross)
      }
    })
  } catch (e) {
    console.log('Issue with Paddle:', { e })
  }
}
